<template>
  <div class="allschool-root">
    <!-- 데스크탑/태블릿: 기존 DataTable 유지 (>640px) -->
    <!-- :key="dataReady" — items가 비어있는 채로 한 번 마운트된 v-data-table은
         이후 실제 데이터가 채워지고 page를 복원해도 1페이지에 고정된 채 반응하지
         않는 Vuetify 쪽 현상이 있어, 데이터가 처음 준비된 시점에 새 인스턴스로
         다시 마운트되게 한다. -->
    <DataTable
      v-if="!isMobile"
      :key="dataReady"
      fill-height
      :headers="tableHeaders"
      :items="tableItems"
      :items-per-page="20"
      :page="curr_page"
      @update:page="setRecentPage"
      scroll-key="allschool"
      row-key="schoolCode"
      density="comfortable"
      :clickable="false"
    >
      <template #toolbar>
        <span class="table-count">
          <b>{{ pad(schools.length) }}</b>건
        </span>
        <div class="toolbar-spacer" />
        <div class="action-btns">
          <!-- 연락처 소스(전체/LMS 인증/수동 등록)를 골라서 다운로드 -->
          <v-menu location="bottom end">
            <template #activator="{ props: menuProps }">
              <v-btn
                v-bind="menuProps"
                variant="outlined"
                size="small"
                color="success"
                append-icon="mdi-menu-down"
              >
                연락처 다운로드
              </v-btn>
            </template>
            <v-list density="compact">
              <v-list-item @click="downloadContacts('all')">
                <v-list-item-title>전체 (LMS 인증 + 수동 등록)</v-list-item-title>
              </v-list-item>
              <v-list-item @click="downloadContacts('lms')">
                <v-list-item-title>LMS 인증 연락처만</v-list-item-title>
              </v-list-item>
              <v-list-item @click="downloadContacts('manual')">
                <v-list-item-title>수동 등록 연락처만</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>

      <template #item.schoolName="{ item }">
        <span class="cell-link" @click="godetail(item.schoolCode)">
          {{ item.schoolName }}
        </span>
      </template>

      <template #item.contractStudentNumber="{ item }">
        {{ getcontractstudentnumber(item.contractYear) ?? "-" }}
      </template>

      <template #item.payPlan="{ item }">
        {{ displayPlan(item.payPlan) }}
      </template>

      <template #item.contractStartDate="{ item }">
        {{ item.contractStartDate || getcontractstartday(item.contractYear) || "-" }}
      </template>

      <template #item.contractEndDate="{ item }">
        {{ item.contractEndDate || getcontractendday(item.contractYear) || "-" }}
      </template>

      <template #item.delete="{ item }">
        <span class="cell-action cell-action--danger" @click="deleteon(item)">
          삭제
        </span>
      </template>

      <template #empty>
        <EmptyState
          title="학교가 없습니다"
          description="신규 학교를 등록해보세요."
          icon="mdi-school-outline"
        >
          <template #action>
            <v-btn @click="goToAccountIssue()" variant="flat" color="primary" size="small">
              학교 등록하러 가기
            </v-btn>
          </template>
        </EmptyState>
      </template>
    </DataTable>

    <!-- 모바일: 카드 리스트 (≤640px) -->
    <div v-else class="mobile-list">
      <div class="mobile-list__toolbar">
        <span class="table-count">
          <b>{{ pad(schools.length) }}</b>건
        </span>
        <div class="toolbar-spacer" />
        <div class="action-btns">
          <v-menu location="bottom end">
            <template #activator="{ props: menuProps }">
              <v-btn
                v-bind="menuProps"
                variant="outlined"
                size="small"
                color="success"
                append-icon="mdi-menu-down"
              >
                연락처
              </v-btn>
            </template>
            <v-list density="compact">
              <v-list-item @click="downloadContacts('all')">
                <v-list-item-title>전체 (LMS 인증 + 수동 등록)</v-list-item-title>
              </v-list-item>
              <v-list-item @click="downloadContacts('lms')">
                <v-list-item-title>LMS 인증 연락처만</v-list-item-title>
              </v-list-item>
              <v-list-item @click="downloadContacts('manual')">
                <v-list-item-title>수동 등록 연락처만</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>

      <div v-if="tableItems.length === 0" class="mobile-empty">
        <EmptyState
          title="학교가 없습니다"
          description="신규 학교를 등록해보세요."
          icon="mdi-school-outline"
        >
          <template #action>
            <v-btn @click="goToAccountIssue()" variant="flat" color="primary" size="small">
              학교 등록하러 가기
            </v-btn>
          </template>
        </EmptyState>
      </div>

      <template v-else>
        <div class="mobile-cards">
          <div
            v-for="item in pagedItems"
            :key="item.schoolCode"
            class="school-card"
            role="button"
            tabindex="0"
            @click="godetail(item.schoolCode)"
            @keyup.enter="godetail(item.schoolCode)"
          >
            <div class="school-card__head">
              <div class="school-card__title">{{ item.schoolName }}</div>
              <v-menu location="bottom end">
                <template #activator="{ props: menuProps }">
                  <v-btn
                    v-bind="menuProps"
                    icon="mdi-dots-vertical"
                    variant="text"
                    size="small"
                    density="comfortable"
                    aria-label="학교 액션"
                    class="school-card__menu-btn"
                    @click.stop
                  ></v-btn>
                </template>
                <v-list density="compact">
                  <v-list-item
                    @click.stop="contacton(item.schoolCode, item.no - 1)"
                  >
                    <v-list-item-title>계정 발급 안내 발송</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click.stop="deleteon(item)"
                    class="school-card__menu-item--danger"
                  >
                    <v-list-item-title>삭제</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div class="school-card__meta">
              <span class="school-card__code">{{ item.schoolCode }}</span>
              <span class="school-card__dot">·</span>
              <span class="school-card__office">{{ item.office || "-" }}</span>
              <template v-if="displayPlan(item.payPlan) !== '-'">
                <span class="school-card__dot">·</span>
                <span class="school-card__plan">{{ displayPlan(item.payPlan) }}</span>
              </template>
            </div>
            <div class="school-card__badges">
              <span class="school-card__student-count">
                계약 학생 수 {{ getcontractstudentnumber(item.contractYear) ?? "-" }}명
              </span>
            </div>
            <div class="school-card__date">
              <span>{{ item.contractStartDate || getcontractstartday(item.contractYear) || "-" }}</span>
              <span class="school-card__date-sep">~</span>
              <span>{{ item.contractEndDate || getcontractendday(item.contractYear) || "-" }}</span>
            </div>
          </div>
        </div>

        <div v-if="totalPages > 1" class="mobile-pagination">
          <v-pagination
            v-model="mobilePage"
            :length="totalPages"
            :total-visible="5"
            density="comfortable"
            rounded="md"
          ></v-pagination>
        </div>
      </template>
    </div>
    <!-- [3차] v-if 가드로 lazy mount — 모달 컨텐츠를 클릭 시점에만 DOM에 삽입해 teleport/parentNode 이슈 회피 -->
    <v-dialog
      v-if="contactmodal"
      persistent
      style="z-index: 9898999"
      :max-width="isMobile ? undefined : 700"
      :fullscreen="isMobile"
      v-model="contactmodal"
    >
      <v-card class="modal-card">
        <div class="modal-header">
          <span style="font-family: notosanslight; font-size: 17px; font-weight: bold">학급 및 전송 연락처 선택</span>
          <span @click="contactoff()" class="modal-close-btn" style="color:red">✖</span>
        </div>
        <div class="modal-body">
          <div class="table-wrap">
            <table style="border-spacing: 0; text-align: center; min-width: 500px; width: 100%">
              <tr>
                <td id="tabletd">이름</td>
                <td id="tabletd">이메일 주소</td>
                <td id="tabletd">전화번호</td>
                <td id="tabletd">메모</td>
                <td id="tabletd">메일 (필수)</td>
                <td id="tabletd">문자 (필수)</td>
              </tr>
              <tr v-for="(j, i) in targetcontactlist" :key="i">
                <td id="tabletd2">{{ j.name }}</td>
                <td id="tabletd2">{{ j.mail }}</td>
                <td id="tabletd2">{{ j.tel }}</td>
                <td id="tabletd2">{{ j.memo || "-" }}</td>
                <td id="tabletd2"><input type="checkbox" v-model="j.mailCheck" /></td>
                <td id="tabletd2"><input type="checkbox" v-model="j.telCheck" /></td>
              </tr>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <p style="font-family: notosansregular; font-size: 14px; color: red; margin: 0">{{ contacttext }}</p>
          <v-btn
            @click="checkcontact()"
            variant="outlined"
            style="color: white; background-color: #747474; font-family: notosanslight; font-weight: bold"
          >확인</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="deleteModalStep1"
      persistent
      v-model="deleteModalStep1"
      :width="isMobile ? undefined : 600"
      :fullscreen="isMobile"
      style="z-index: 99999"
    >
      <v-card class="modal-card">
        <div class="modal-header">
          <span style="font-family: notosansregular; font-size: 17px"><b>삭제 확인</b></span>
          <span @click="deleteoff()" class="modal-close-btn">X</span>
        </div>
        <div class="modal-body" style="font-family: notosansregular">
          이 학교를 삭제하시겠습니까? 소속된 학생, 교사 데이터가 모두 영구 삭제됩니다.
        </div>
        <div class="modal-footer">
          <v-btn @click="deleteStep1Confirm()" variant="outlined" class="registerbtn">확인</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="deleteModalStep2"
      persistent
      v-model="deleteModalStep2"
      :max-width="isMobile ? undefined : 500"
      :fullscreen="isMobile"
      style="z-index: 99999"
    >
      <v-card class="modal-card">
        <div class="modal-header">
          <span style="font-family: notosansregular; font-size: 17px"><b>삭제 최종 확인</b></span>
          <span @click="deleteoff()" class="modal-close-btn">X</span>
        </div>
        <div class="modal-body" style="font-family: notosansregular">
          <div style="margin-bottom: 12px">삭제할 학교명을 정확히 입력해주세요.</div>
          <div class="delete-input-wrap">
            <span class="delete-hint">{{ getDeleteHintText() }}</span>
            <input v-model="deleteConfirmName" class="registerinput delete-input" type="text" />
          </div>
          <div style="margin-top: 15px">
            <input type="checkbox" v-model="deleteConfirmCheck" />
            <span style="margin-left: 6px">데이터가 복구되지 않음을 확인했습니다.</span>
          </div>
        </div>
        <div class="modal-footer">
          <v-btn @click="deleteSchoolConfirm()" :disabled="!canDeleteSchool()" variant="outlined" class="registerbtn">삭제</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  changeschoolpaystatus,
  changeschoolaccountstatus,
} from "@/api/user-api-list";
import DataTable from "@/components/ui/DataTable.vue";
import EmptyState from "@/components/ui/EmptyState.vue";
import { instanceAuth } from "@/api/url";
import { getLastFromPath } from "@/router";

export default {
  components: { DataTable, EmptyState },
  created() {
    // 상세 페이지에서 뒤로가기로 돌아온 경우에만 페이지/스크롤을 복원한다.
    // 새로고침하거나 다른 탭에서 넘어온 경우엔(즉 이 컴포넌트가 새로 마운트되는
    // 모든 경우) 맨 위 1페이지로 시작 — schools watch에서 이 값을 확인한다.
    this.cameFromDetail = /^\/(user\/school-manage|guest\/guest-manage)\//.test(
      getLastFromPath() || ""
    );
    if (!this.cameFromDetail) {
      sessionStorage.removeItem("dataTableScroll:allschool");
    }
  },
  data() {
    return {
      curr_page: 1,
      dataReady: false,
      cameFromDetail: false,
      pickofficemodal: false,
      contactmodal: false,
      schoolcode: "",
      schoolIndex: "",
      targetcontactlist: [],
      contactbtntext: "확인",
      contacttext: "",
      deleteModalStep1: false,
      deleteModalStep2: false,
      deleteTarget: null,
      deleteConfirmName: "",
      deleteConfirmCheck: false,
      windowWidth: typeof window !== "undefined" ? window.innerWidth : 1920,
      mobilePage: 1,
      mobilePageSize: 10,
    };
  },
  mounted() {
    this._onResize = () => {
      this.windowWidth = window.innerWidth;
    };
    window.addEventListener("resize", this._onResize);
  },
  beforeUnmount() {
    if (this._onResize) {
      window.removeEventListener("resize", this._onResize);
    }
  },
  watch: {
    schools(newSchools) {
      if (!this.dataReady && newSchools && newSchools.length > 0) {
        // 최초로 데이터가 채워지는 시점 — 상세 페이지에서 돌아온 경우에만 저장해둔
        // 페이지로 복원하고, DataTable을 새 key로 다시 마운트해서 반영한다.
        this.dataReady = true;
        if (this.tab === 1 && this.cameFromDetail) {
          const page = parseInt(sessionStorage.getItem("recentPage"), 10);
          this.curr_page = Number.isFinite(page) && page > 0 ? page : 1;
        }
      }
      this.mobilePage = 1;
    },
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 640;
    },
    pagedItems() {
      const start = (this.mobilePage - 1) * this.mobilePageSize;
      return this.tableItems.slice(start, start + this.mobilePageSize);
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.tableItems.length / this.mobilePageSize));
    },
    tableHeaders() {
      const w = this.windowWidth;
      // 브레이크포인트: <=768 좁음, <=1280 중간, >1280 넓음
      const showMedium = w > 1024;     // 교육청, 요금제
      const showDate = w > 900;        // 계약 시작/만료일
      const showCode = w > 640;        // 학교코드

      const headers = [
        { title: "No", key: "no", sortable: false, align: "center", width: 60, cellClass: "cell-nowrap" },
      ];
      if (showMedium) {
        headers.push({ title: "교육청", key: "office", sortable: true, align: "center", width: 140, cellClass: "cell-nowrap" });
      }
      headers.push({ title: "학교 이름", key: "schoolName", sortable: true, align: "center", width: 220, cellClass: "cell-school-name" });
      if (showCode) {
        headers.push({ title: "코드", key: "schoolCode", sortable: true, align: "center", width: 120, cellClass: "cell-code" });
      }
      headers.push(
        { title: "계약 학생 수", key: "contractStudentNumber", sortable: false, align: "center", width: 110, cellClass: "cell-nowrap" },
      );
      if (showMedium) {
        headers.push({ title: "플랜", key: "payPlan", sortable: true, align: "center", width: 90, cellClass: "cell-nowrap" });
      }
      if (showDate) {
        headers.push(
          { title: "계약 시작일", key: "contractStartDate", sortable: true, align: "center", width: 120, cellClass: "cell-nowrap" },
          { title: "계약 만료일", key: "contractEndDate", sortable: true, align: "center", width: 120, cellClass: "cell-nowrap" },
        );
      }
      headers.push(
        { title: "삭제", key: "delete", sortable: false, align: "center", width: 80, cellClass: "cell-nowrap" },
      );
      return headers;
    },
    tableItems() {
      // 등록일(createdAt) 최신순 정렬 후 index를 슬롯에 전달할 no 필드로 부여
      const sorted = [...(this.schools || [])].sort(
        (a, b) => this.createdAtMillis(b) - this.createdAtMillis(a)
      );
      return sorted.map((s, idx) => ({ ...s, no: idx + 1 }));
    },
  },
  methods: {
    // 학교 생성 시각 추출. createdAt → _id timestamp 순으로 fallback
    // (GUEST 등록/수정 SchoolTableComponent.vue와 동일한 규칙)
    createdAtMillis(school) {
      if (school?.createdAt) {
        const t = new Date(school.createdAt).getTime();
        if (!Number.isNaN(t)) return t;
      }
      const id = school?._id;
      if (typeof id === "string" && id.length >= 8) {
        const secs = parseInt(id.substring(0, 8), 16);
        if (Number.isFinite(secs)) return secs * 1000;
      }
      return 0;
    },
    pad(num) {
      return num < 10 ? num.toString().padStart(2, "0") : num;
    },
    // general, premium으로 저장하되 UI 에서는 s와 p로 보이게 설정
    displayPlan(plan) {
      if (!plan) {
        return "-";
      }
      if (plan === "premium") {
        return "p";
      }
      if (plan === "general") {
        return "s";
      }
      return plan;
    },
    goToAccountIssue() {
      this.$router.push("/user/account-issue");
    },
    pickofficeon() {
      this.pickofficemodal = !this.pickofficemodal;
    },
    pickoffice(str) {
      this.office = str;
      this.pickofficemodal = false;
    },
    godetail(code) {
      this.$router.push(`/user/school-manage/${code}`);
    },
    async sendaccountguide(email, name) {
      const data = { email, name, password: "000000" };
      const res = await this.$store.dispatch("SEND_ACCOUNT_GUIDE_MAIL", data);
      if (res.message == "good") {
        alert(`${email} 으로\n계정 발급 안내 메일이 발송되었습니다.`);
      }
      if (res.message == "error") {
        alert("이메일 발송에 실패하였습니다.");
      }
    },
    get_page_length() {
      return Math.ceil(this.schools.length / 10);
    },
    paging(data) {
      const size = 10;
      const arr = [];

      for (let i = 0; i < data.length; i += size) {
        arr.push(data.slice(i, i + size));
      }

      return arr;
    },
    async contacton(schoolCode, index) {
      const res = await this.$store.dispatch("GET_SCHOOL_CONTACT", schoolCode);
      this.schoolcode = schoolCode;
      this.schoolIndex = index;
      this.targetcontactlist = res;
      this.contactmodal = true;
    },
    contactoff() {
      this.contactmodal = false;
      this.targetcontactlist = [];
    },
    getcontractstartday(data) {
      if (data.length == 0) {
        return "-";
      }
      const date = new Date();
      const year = date.getFullYear();

      for (let i = 0; i < data.length; i++) {
        if (data[i].year != year) {
          continue;
        } else {
          return data[i].startDate;
        }
      }
    },
    getcontractendday(data) {
      if (data.length == 0) {
        return "-";
      }
      const date = new Date();
      const year = date.getFullYear();

      for (let i = 0; i < data.length; i++) {
        if (data[i].year != year) {
          continue;
        } else {
          return data[i].endDate;
        }
      }
    },
    getcontractstudentnumber(data) {
      if (data.length == 0) {
        return "-";
      }
      const date = new Date();
      const year = date.getFullYear();

      for (let i = 0; i < data.length; i++) {
        if (data[i].year != year) {
          continue;
        } else {
          return data[i].contractStudentNumber;
        }
      }
    },
    async checkcontact() {
      const emailarr = this.targetcontactlist.filter(
        (item) => item.mailCheck == true,
      );
      const telarr = this.targetcontactlist.filter(
        (item) => item.telCheck == true,
      );

      if (!emailarr.length || !telarr.length) {
        this.contacttext = "필수 입력 항목을 선택해주세요.";
        return;
      } else {
        this.contacttext = "";
      }

      let emailList = [];
      let telList = [];

      for (let i = 0; i < emailarr.length; i++) {
        emailList.push(emailarr[i].mail);
      }

      for (let i = 0; i < telarr.length; i++) {
        telList.push(telarr[i].tel);
      }

      if (
        window.confirm(
          `메일 ${emailList.length}건 문자 ${telList.length}건\n전송하시겠습니까?`,
        )
      ) {
        const res = await this.$store.dispatch("SEND_ACCOUNT_GUIDE_MAIL", {
          emailList,
        });
        const res2 = await this.$store.dispatch("SEND_ACCOUNT_GUIDE_SMS", {
          telList,
        });

        if (res.message == "good" && res2.message == "good") {
          const res3 = await changeschoolaccountstatus({
            schoolCode: this.schoolcode,
            accountStatus: "정보대기",
          });

          if (res3.data.data) {
            this.schools[this.schoolIndex].accountStatus = "정보대기";
          }

          alert(
            `메일 ${emailList.length}건 문자 ${telList.length}건\n전송되었습니다`,
          );

          this.targetcontactlist = [];
          this.contactmodal = false;
          this.schoolIndex = "";
          this.schoolcode = "";
        }
      }
    },
    async downloadContacts(source = "all") {
      // url.js의 baseURL 설정을 따라간다 (로컬/운영 전환 시 하드코딩 수정 불필요)
      // 이 화면은 유료 학교 목록 전용.
      // source: all(전체) / lms(LMS 인증 연락처만) / manual(수동 등록 연락처만)
      window.open(
        `${instanceAuth.defaults.baseURL}/schools/download/contact?category=paid&source=${source}`
      );
    },
    deleteon(school) {
      // 삭제 대상(학교명/코드)을 저장하고 1차 경고 모달을 연다.
      this.deleteTarget = school;
      this.deleteConfirmName = "";
      this.deleteConfirmCheck = false;
      this.deleteModalStep1 = true;
    },
    deleteoff() {
      // 삭제 플로우 전체 초기화(모달/입력/선택 상태).
      this.deleteModalStep1 = false;
      this.deleteModalStep2 = false;
      this.deleteTarget = null;
      this.deleteConfirmName = "";
      this.deleteConfirmCheck = false;
    },
    deleteStep1Confirm() {
      // 1차 경고 확인 후 2차 확인 모달로 전환한다.
      this.deleteModalStep1 = false;
      this.deleteModalStep2 = true;
    },
    getDeleteHintText() {
      // 입력값 뒤에 남은 학교명을 힌트로 이어서 보여준다.
      if (!this.deleteTarget) return "";
      const target = this.deleteTarget.schoolName || "";
      const input = this.deleteConfirmName || "";
      if (!input) return target;
      if (target.startsWith(input)) {
        return input + target.slice(input.length);
      }
      return target;
    },
    canDeleteSchool() {
      // 학교명 입력이 정확히 일치하고 체크박스가 확인된 경우에만 활성화.
      if (!this.deleteTarget) return false;
      const nameMatch = this.deleteConfirmName === this.deleteTarget.schoolName;
      return nameMatch && this.deleteConfirmCheck;
    },
    async deleteSchoolConfirm() {
      // 2차 확인을 통과한 경우에만 삭제 API를 호출한다.
      if (!this.deleteTarget) return;
      if (!this.canDeleteSchool()) return;

      const schoolCode = this.deleteTarget.schoolCode;
      const res = await this.$store.dispatch("DELETE_SCHOOL", schoolCode);

      if (res) {
        // 삭제 성공 시 리스트에서 즉시 제거하여 화면에 반영.
        const idx = this.schools.findIndex(
          (item) => item.schoolCode === schoolCode,
        );
        if (idx > -1) {
          this.schools.splice(idx, 1);
        }
        alert("삭제 완료되었습니다.");
        this.deleteoff();
        return;
      } else {
        alert("삭제 실패했습니다.");
      }
    },
    setRecentPage(num) {
      this.curr_page = num;
      if (this.tab === 1) {
        sessionStorage.setItem("recentPage", num);
      }
    },
  },
  props: {
    tab: {
      type: Number,
    },
    schools: {
      type: Array,
    },
  },
};
</script>

<style scoped>
/* (legacy) — 메인 학교 테이블은 DataTable로 이전. 아래 셀렉터는 모달 내부 테이블에서만 사용됨. */
#tabletd {
  border: 1px solid var(--border-default);
  font-family: notosanslight;
  padding: 8px;
  font-size: 13px;
  background-color: var(--bg-subtle);
  white-space: nowrap;
}

#tabletd2 {
  border: 1px solid var(--border-default);
  font-family: notosanslight;
  font-weight: bold;
  padding: 10px;
  font-size: 13px;
  white-space: nowrap;
}

/* DataTable toolbar 슬롯 내부 */
.table-count {
  font-size: var(--font-small-size);
  color: var(--text-secondary);
}
.toolbar-spacer {
  flex: 1;
}
.action-btns {
  display: flex;
  gap: var(--space-2);
  flex-wrap: wrap;
}

/* 셀 내부 인터랙션 */
.cell-link {
  color: var(--color-primary-700);
  cursor: pointer;
  text-decoration: underline;
  font-weight: 600;
}
.cell-link:hover {
  color: var(--color-primary-900);
}
.cell-action {
  cursor: pointer;
  text-decoration: underline;
  font-weight: 600;
  color: var(--color-primary-700);
}
.cell-action:hover {
  color: var(--color-primary-900);
}
.cell-action--danger {
  color: var(--color-error-text);
}
.cell-action--danger:hover {
  color: #8a1a12;
}
.cell-muted {
  color: var(--text-tertiary);
}

/* 셀 내용 가운데 정렬 강제 — 이 페이지 컬럼은 전부 가운데 정렬이 맞아서
   th/td 모두에 직접 지정 (헤더 align 설정에만 의존하지 않음). 정렬 아이콘
   자리 때문에 헤더/값이 어긋나는 문제는 DataTable.vue에서 공통 처리한다. */
:deep(.v-table__wrapper table th),
:deep(.v-table__wrapper table td) {
  text-align: center;
}

/* 반응형 테이블 셀 wrap 처리 — v-data-table td에 cellClass로 전달됨 */
:deep(td.cell-nowrap) {
  white-space: nowrap;
}
:deep(td.cell-code) {
  white-space: nowrap;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12.5px;
  letter-spacing: 0.2px;
}
:deep(td.cell-school-name) {
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
  min-width: 200px;
  max-width: 320px;
  line-height: 1.4;
}
/* 좁은 폭에서 셀 패딩 축소 */
@media (max-width: 900px) {
  :deep(.data-table__inner) :deep(tbody td),
  :deep(.data-table__inner) :deep(thead th) {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
}

/* 모달 공통 */
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-default);
}

.modal-close-btn {
  font-size: 20px;
  cursor: pointer;
  line-height: 1;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 20px;
  background: var(--bg-subtle);
  border-top: 1px solid var(--border-default);
}

.registerinput {
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-lg);
  font-size: 14px;
  padding: 10px;
  font-family: notosansregular;
  width: 100%;
}

.registerbtn {
  font-family: notosansregular;
  font-size: 15px;
  background-color: var(--color-primary-600);
  color: var(--text-on-primary);
  border: 1px solid var(--color-primary-600);
}

.delete-input-wrap {
  position: relative;
  width: 250px;
}

.delete-hint {
  position: absolute;
  left: 11px;
  top: 10px;
  color: #b0b0b0;
  font-size: 14px;
  font-family: notosansregular;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 1.4;
  pointer-events: none;
  white-space: nowrap;
  z-index: 1;
  box-sizing: border-box;
}

.delete-input {
  position: relative;
  background: transparent;
  z-index: 2;
  font-size: 14px;
  font-family: notosansregular;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 1.4;
  box-sizing: border-box;
}

.pickofficemodal {
  width: 230px;
  height: 130px;
  position: absolute;
  border: 1px solid gray;
  z-index: 88;
  background-color: white;
  overflow-y: scroll;
  font-family: notosansregular;
  border-radius: 5px;
}

.registeroff {
  font-weight: bold;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 25px;
  padding: 11px;
  margin-right: 10px;
  cursor: pointer;
}

.officetext {
  float: left;
  font-size: 14px;
  color: black;
  font-family: notosanslight;
  margin-top: 7px;
  margin-left: 10px;
}

.pickofficebox {
  width: 230px;
  height: 36px;
  border: 1px solid gray;
  cursor: pointer;
  border-radius: 8px;
}

/* ── 모바일 카드 리스트 (≤640px) ──
   데스크탑과 동일하게 툴바/페이지네이션은 고정, 카드 목록(.mobile-cards)만
   내부 스크롤되도록 flex-column + flex:1 min-height:0 구성. */
.allschool-root {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.mobile-list {
  background: var(--bg-surface);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.mobile-list__toolbar {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--border-default);
  background: var(--bg-surface);
  flex: 0 0 auto;
}

.mobile-empty {
  padding: var(--space-6);
  overflow-y: auto;
}

.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-3);
  background: var(--bg-canvas);
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.school-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  padding: var(--space-4);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  cursor: pointer;
  transition: border-color 120ms ease, background 120ms ease;
}
.school-card:hover,
.school-card:focus-visible {
  border-color: var(--border-strong);
  background: var(--color-primary-50);
  outline: none;
}

.school-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-2);
}
.school-card__title {
  font-size: var(--font-h3-size, 16px);
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.4;
  word-break: keep-all;
  overflow-wrap: anywhere;
  flex: 1;
}
.school-card__menu-btn {
  margin-top: -4px;
  margin-right: -8px;
}
.school-card__menu-item--danger :deep(.v-list-item-title) {
  color: var(--color-error-text);
}

.school-card__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-1);
  font-size: var(--font-caption-size, 12px);
  color: var(--text-tertiary);
  line-height: 1.5;
}
.school-card__code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  color: var(--text-secondary);
}
.school-card__dot {
  color: var(--text-tertiary);
  margin: 0 2px;
}

.school-card__badges {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-top: var(--space-1);
}
.school-card__student-count {
  font-size: var(--font-small-size, 13px);
  color: var(--text-secondary);
}

.school-card__date {
  font-size: var(--font-small-size, 13px);
  color: var(--text-secondary);
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}
.school-card__date-sep {
  color: var(--text-tertiary);
}

.mobile-pagination {
  display: flex;
  justify-content: center;
  padding: var(--space-3);
  border-top: 1px solid var(--border-default);
  background: var(--bg-surface);
  flex: 0 0 auto;
}

/* ── 모달 풀스크린 모드 (≤640px) ── */
@media (max-width: 640px) {
  .modal-card {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }
  .modal-card .modal-body {
    flex: 1;
    overflow-y: auto;
  }
  .modal-card .modal-footer {
    position: sticky;
    bottom: 0;
  }
  .delete-input-wrap {
    width: 100%;
  }
  /* 연락처 테이블: 가로 스크롤 허용 */
  .modal-body .table-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
